import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function RoleGuard({ roles }) {
  const { user, isAuthenticated } = useSelector((s) => s.auth);

  if (!isAuthenticated || !user) return <Navigate to="/login" replace />;

  return roles.includes(user.role)
    ? <Outlet />
    : <Navigate to="/unauthorized" replace />;
}
